
(function (window, document, jQuery, undefined) {
    // map jQuery to local var
    var $ = jQuery.noConflict();

    // get infographic numbers to animate
    var $numbers = $(".don-infographic__number");

    // apply magic
    $numbers.each(function () {
        // prepare value to animate
        var valueOrig = this.innerHTML;
        var valueCount = 0;
        var valueCountMax = valueOrig.includes(".")
            ? valueOrig.substr(0, valueOrig.indexOf("."))
            : valueOrig;
        var valueSuffix = valueOrig.includes(".")
            ? valueOrig.substr(valueOrig.indexOf("."))
            : "";

        // used timer
        var timer;
        var finished = false;
        var running = false;

        // make this accessible in functions that having an own this
        var that = this;

        // start timer if entering viewport
        $(window).on("load resize scroll", function (e) {
            if (inView.is(that) && finished === false && running === false) {
                var milliSeconds = valueCountMax < 100 ? 50 : valueCountMax < 300 ? 30 : valueCountMax < 600 ? 10 : 2;
                timer = setInterval(count, milliSeconds);
                running = true;
            }
        });

        // increase value by timer
        function count() {
            valueCount++;
            that.innerHTML = valueCount + valueSuffix;
            if (valueCount >= valueCountMax) {
                clearInterval(timer);
                finished = true;
            }
        }
    });
})(window, document, jQuery);
